import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { LINKS } from "../data/site";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={LINKS.whatsapp}
      target="_blank"
      rel="noreferrer"
      initial={{ scale: 0, rotate: -30 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ delay: 1.7, type: "spring", stiffness: 160, damping: 14 }}
      data-testid="whatsapp-float-button"
      aria-label="Conversar com a Anime Glam no WhatsApp"
      className="fixed bottom-5 right-5 z-[80] grid h-14 w-14 place-items-center rounded-full bg-wa text-white shadow-[0_12px_32px_rgba(37,211,102,0.5)] transition-transform duration-300 hover:scale-110"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-wa/40 [animation-duration:2.6s]" aria-hidden="true" />
      <MessageCircle size={26} className="relative" />
    </motion.a>
  );
}
